<section class="content-header" style="padding: 0.5% !important;">
    <div class="container-fluid">
        <div class="row mb-2">
            <div class="col-md-6">
                <ol class="breadcrumb float-sm-left">
                    <li class="breadcrumb-item">
                        <a [routerLink]="['/']"><i class="fas fa-home"></i> &nbsp;Trang chủ</a>
                    </li>
                    <li class="breadcrumb-item active">Hồ sơ của tôi</li>
                </ol>
            </div>
            <div class="col-md-6">
                <button (click)="help()" class="btn btn-warning btn-sm"  type="submit" style="float: right; ">
                    <i class="fas fa-info-circle"></i>
                    Hướng dẫn
                </button>
            </div>
        </div>
    </div>
</section>
<!-- Main content -->
<section class="content">
  <div class="container-fluid">
    <div class="row">
      <div class="col-md-12">
          <div class="card card card-primary">
              <div class="card-header no-border">
                <div class="row">
                    <div class="{{TitleClass}}"></div>
                    <div class=" col-md-3"><h3 class="card-title" >{{Title}}</h3></div>
                </div>
              </div>
              <div class="card-body">
                  <div class="tab-content">
                      <div class="active tab-pane" id="TeachInfo">
                          <form class="form-horizontal" [formGroup]="UserForm">
                              <div class="row">
                                  <div class="col-md-6">
                                      <div class="form-group">
                                          <label for="inputName" class="col-sm-6 control-label">
                                            <i class="fas fa-user-circle"></i>  
                                            Họ và tên
                                          </label>
                                          <div class="col-sm-10">
                                              <input type="text"  class="form-control" formControlName="Ho_ten" id="Ho_ten" value="" readonly placeholder="Name">
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-6">
                                      <div class="form-group">
                                          <label for="inputEmail" class="col-sm-6 control-label">
                                            <i class="far fa-id-badge"></i>
                                            Mã giảng viên
                                          </label>

                                          <div class="col-sm-10">
                                              <input type="email" class="form-control" readonly formControlName="Ma_cb" id="Ma_cb" placeholder="Email">
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-6">
                                      <div class="form-group">
                                          <label for="inputName" class="col-sm-6 control-label">
                                            <i class="far fa-calendar-minus"></i>  
                                            Ngày sinh
                                          </label>
                                          <div class="col-sm-10">
                                              <input type="date" class="form-control" readonly formControlName="Ngay_sinh" id="Ngay_sinh" placeholder="Chưa có thông tin">
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-6">
                                      <div class="form-group">
                                          <label for="inputName2" class="col-sm-6 control-label">
                                            <i class="fas fa-mobile-alt"></i>
                                            Số điện thoại
                                          </label>

                                          <div class="col-sm-10">
                                              <input type="text" class="form-control" formControlName="So_dien_thoai" id="So_dien_thoai" placeholder="Nhập số điện thoại...">
                                          </div>
                                      </div>
                                  </div>
                              </div>
                              <div class="row">
                                  <div class="col-md-6">
                                      <div class="form-group">
                                          <label for="inputName2" class="col-sm-6 control-label">
                                            <i class="far fa-envelope"></i>  
                                            Địa chỉ email
                                          </label>

                                          <div class="col-sm-10">
                                              <input type="email" class="form-control" id="Email" formControlName="Email" placeholder="Nhập địa chỉ email">
                                          </div>
                                      </div>
                                  </div>
                                  <div class="col-md-6">
                                      <div class="form-group">
                                          <label for="inputExperience" class="col-sm-6 control-label">
                                            <i class="fas fa-map-marker-alt"></i>
                                            Địa chỉ liên hệ
                                          </label>

                                          <div class="col-sm-10">
                                              <textarea class="form-control" id="Dia_chi_lien_he" formControlName="Dia_chi_lien_he" placeholder="Nhập địa chỉ liên hệ..."></textarea>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </form>
                      </div>
                      <div class="tab-pane" id="settings">
                          <form class="form-horizontal"></form>
                      </div>
                      <!-- /.tab-pane -->
                  </div>
                  <!-- /.tab-content -->
              </div><!-- /.card-body -->
              <div class="card-footer">
                    <p   (click)="UpdateInfo()" class="btn btn-success float-sm-right cs-i-c">
                        <i class="fas fa-save"></i> Lưu thông tin
                    </p>
              </div>
          </div>
      </div>
      <!-- /.col -->
  </div>
    <!-- /.row -->
  </div>
  <!-- /.container-fluid -->
</section>


